import { useGetUserProviders, useItemsRemoveConfirm, useRemoveUserProvider } from 'src/hooks'
import { EUserProviders, IUserProviderResponse } from 'src/types'

import { useStyles } from './../../styles'
import { Box, Button } from '@mui/material'
import { LoginProviderListItem } from './login-provider-list-item.component'
import { Loader } from 'src/components/loader'
import { TwitterIcon } from 'src/assets/icons'
import { getUserIdAndRolesFromToken } from 'src/common/utils'

interface IProps {
  providers: void | IUserProviderResponse[] | undefined
  isLoading: boolean
  showConnectToXButton: boolean
}

const LoginProvidersModalInner = ({ providers, isLoading, showConnectToXButton }: IProps) => {
  const classes = useStyles()

  const { mutateAsync: removeProvider } = useRemoveUserProvider()

  const { setRemoveConfirm } = useItemsRemoveConfirm()

  const handlerProviderDisconect = async (provider: EUserProviders) => {
    setRemoveConfirm({
      handleConfirm: async () => {
        await removeProvider(provider)
      },
      itemsTitles: [],
      itemsRelations: [],

      itemsType: `${provider} provider`,
    })
  }

  const handleConnectX = () => {
    const userData = getUserIdAndRolesFromToken()

    const userId = userData?.id

    if (userId) {
      const customState = 'user_profile_connect_to_x-'
      window.open(
        `${process.env.REACT_APP_BACKEND_URL}/auth/x?token=${customState}${userId}`,
        '_self',
      )
    }
  }

  if (isLoading || !providers) {
    return <Loader />
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      {providers.map((item) => (
        <LoginProviderListItem
          name={item.provider}
          identifier={item?.provider_identifier || ''}
          handlerProviderDisconect={handlerProviderDisconect}
        />
      ))}
      {showConnectToXButton && (
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
          <Button variant="outlined" startIcon={<TwitterIcon />} onClick={handleConnectX}>
            Connect to X
          </Button>
        </Box>
      )}
    </Box>
  )
}

export { LoginProvidersModalInner }
